import { useMutation } from "@tanstack/react-query";

import axios from "../../../utils/axiosInceptor";
import { apiV1Endpoint } from "../endpoints";
import { ApiResponse } from "../types";

import { UploadFileResult } from "./types";

export type UploadFileOptions = {
  file: File;
  path: string;
  isSigned?: boolean;
};

async function uploadFile(options: UploadFileOptions) {
  const { file, path, isSigned = false } = options;

  const formData = new FormData();
  formData.append("file_asset", file);
  formData.append("path", path);
  formData.append("isSigned", String(isSigned));

  const url = `${apiV1Endpoint}/document/uploadFile`;
  const response = await axios.post<ApiResponse<UploadFileResult>>(url, formData);
  return response.data.result;
}

export const useUploadFile = () => {
  const mutation = useMutation({
    mutationFn: uploadFile,
  });

  return {
    uploadFileAsync: mutation.mutateAsync,
    isUploadingFile: mutation.isLoading,
  };
};
